module.exports = __webpack_public_path__ + "img/7a2e080.png";